import { Dispatch } from "redux";
import { toast } from "react-toastify";
import { setDashbaordData, setIsLoadingData } from "./reducer";
import { formatDateTimeAmPm } from "utils/tools";


export const getDashboardData = () => async (dispatch: Dispatch) => {
    dispatch(setIsLoadingData(true))
    try {
        const url = `${process.env.REACT_APP_API_URL}/dashboard`;
        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET'
        });

        if (!res.ok) {
            const errRes = await res.json();
            toast.error(errRes.message);
            return;
        }

        const data = await res.json();
        const userCount = data.data.userCount;
        const syncLog = data.data.syncLog;

        dispatch(setDashbaordData({
            userCount: userCount,
            lastSync: syncLog ? formatDateTimeAmPm(syncLog.syncedAt) : "Not Found"
        }))
    } catch (err: any) {
        toast.error("Something went wrong. Could not sync data")
        console.error('Error syncing data:', err);
    } finally {
        dispatch(setIsLoadingData(false))

    }
} 